import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { statusMappings } from 'src/app/common/enums/Status';
import { PricePipe } from 'src/app/common/pipes/price.pipe';

@Component({
	selector: 'app-bag-reservation-list-statistic',
	templateUrl: './bag-reservation-list-statistic.component.html',
	styleUrls: ['./bag-reservation-list-statistic.component.scss'],
	providers: [PricePipe],
})
export class BagReservationListStatisticComponent implements OnChanges {
	@Input() data;

	constructor(protected pricePipe: PricePipe) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.data) {
			return;
		}
		this.displayStatisticLabel(this.data);
	}

	protected displayStatisticLabel(data): void {
		data.forEach((element) => {
			if (statusMappings[element.kind]) {
				element.label = statusMappings[element.kind];
			} else {
				element.label = 'Wszystkie';
			}
		});
		return data;
	}
}
